const lastDate = {
    year: 2026,
    month: 7,
    day: 16
}

export default lastDate